import React from 'react';

import Checkbox from 'components/DesignSystem/Checkbox';
import useFluxFileUploadForm from 'utils/hooks/flux/fileUploadForm';

const PRODUZIR_MAPAS_LABEL = 'Produzir mapas de preciptação';

function OutputOptionCheckbox(label: string) {
  const { outputOptions, toggleOutputOption } = useFluxFileUploadForm();
  const isMapasPrecipitacao = label === PRODUZIR_MAPAS_LABEL;

  return (
    <Checkbox
      label={label}
      key={label}
      checked={isMapasPrecipitacao ? false : outputOptions.includes(label)}
      disabled={isMapasPrecipitacao}
      onChange={isMapasPrecipitacao ? () => {} : () => toggleOutputOption(label)}
    />
  );
}

export default function OutputOptions() {
  const labels = [
    PRODUZIR_MAPAS_LABEL,
    'Produzir arquivo excel PMED',
    'Produzir arquivos DESSEM',
    'Produzir arquivo.csv de ENA diária',
    'Produzir memória de cálculo ENA semanal',
    'Produzir arquivos PREVS.RVX mensais',
    'Produzir arquivos VAZPAST.DAT',
  ];

  return (
    <div>
      {labels.map((label) => OutputOptionCheckbox(label))}
    </div>
  );
}
